import "./ConnectWithUs.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import FaleConosco from "./sections/FaleConosco";
import OurLocations from "./sections/OurLocations";
import UbicacionYContacto from "./sections/UbicacionYContacto";
import Footer from "@/reusable_sections/Footer";
export default function ConnectWithUsPage() {
  return <div>
      <Header />
      <Hero />
      <FaleConosco />
      <OurLocations />
      <UbicacionYContacto />
      <Footer />
    </div>;
}